import type { TMeter } from 'api/models/TMeter';

export const isPrimaryRelatedMeter = (meter: TMeter) => {
  return meter.relatedMPANStatus === 'Primary';
};

export const isRelatedMeter = (meter: TMeter) => {
  return (
    meter.relatedMPANStatus === 'Primary' ||
    meter.relatedMPANStatus === 'Secondary'
  );
};

export const hasMixedAndStandardRelatedMeters = (meters: TMeter[]): boolean => {
  const hasRelated = meters.some(isRelatedMeter);
  const hasStandard = meters.some((meter) => !isRelatedMeter(meter));

  return hasRelated && hasStandard;
};

export const hasMultiplePrimaryMeters = (meters: TMeter[]): boolean => {
  const hasMultiplePrimaryMeters =
    meters.filter(isPrimaryRelatedMeter).length > 1;

  return hasMultiplePrimaryMeters;
};
